import { commonEnvironment } from "./environment-common";

export const environment = {
  ...commonEnvironment,
  botName: "arole",
  backendBaseUrl: "https://ui-api.arolebot-out-prod.probayes.net/v0/",
  opened: false,

  headerLogoUrl: "/assets/specific/arole/avatar-ring.svg",
  reducedBotLogoUrl: "/assets/specific/arole/avatar-reduced-bot.svg",
  reducedBotHasWelcomeText: true,
  messageAvatarUrl: "/assets/specific/arole/avatar.svg",
};
